import React, { useEffect, useState } from 'react'
import VitalParameterTable from './vitalParameterTable';
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Spin } from 'antd';
import { fetchRpmVitalsRangeList } from '../../../../Redux/actions/rpmActions';
import nodatafound from "../../../../Assets/Icons/NoDataCard2.svg";
import Layout from '../../../Layouts';

function Index() {
  const [currentPage, setCurrentPage] = useState(1);
  const { isLoading, vitalRangesList } = useSelector((state) => state.rpm);
  const dispatch = useDispatch();


  useEffect(() => {
    const payload = {
      status: 1
    }
    dispatch(fetchRpmVitalsRangeList(payload));
  }, []);


  return (
    <Layout>
      <div className="p-3">
        <div className="flex justify-between items-center py-3 px-6 sticky top-3">
          <div className="">
            <h1 className="font-bold text-xl">Vitals Parameters</h1>
          </div>
        </div>
        <div className={`${isLoading === false && vitalRangesList?.length === 0 ? 'w-full flex justify-center items-center' : 'overflow-y-scroll h-[23rem] scrollWidth'}`}>
          {isLoading && vitalRangesList?.length === 0 ? (
            <div className="flex items-center justify-center mt-[10%]">
              <Flex align="center" gap="middle">
                <Spin size="large" tip="Loading" />
              </Flex>
            </div>
          ) :
            vitalRangesList?.length === 0 ?
              (<div className="flex flex-col items-center justify-center">
                <img src={nodatafound} alt="nodatafound" className="h-min w-min" />
                <p className="font-medium text-xl">No data found!!</p>
              </div>)
              :
              (
                <div>
                  <VitalParameterTable
                    data={vitalRangesList}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalCount={vitalRangesList?.length}
                  />
                </div>
              )}

        </div>
      </div>
    </Layout>
  )
}

export default Index;